import ResumePoints from './ResumePoints';

const resolveResumePointsActions = value => ({
    updateResumePoints(nextResumePointsData) {
        Object.assign(value, new ResumePoints(), nextResumePointsData);
    },
    disableFeature() {
        value.isEnabled = false;
    },
});

export default resolveResumePointsActions;
